export type TypeOfReport =
  | 'OUS'
  | 'DDU'
  | 'DSU'
  | 'DUBG'
  | 'SUBG'
  | 'ISR'
  | 'OSR'
  | 'UGR'
  | 'SRISR';

export const ReportList = [
  {
    name: 'Summary Reports',
    description:
      'These reports provide a summative total based on the time period selected.Multiple Products may be selected.',
    data: [
      {
        key: 'OSR',
        value: 'Overall Summary Report',
      },
      {
        key: 'UGR',
        value: 'User Group Report',
      },
      {
        key: 'SRISR',
        value: 'Individual Site Report',
      },
    ],
  },
  {
    name: 'Detailed Reports',
    description:
      'These reports provide a monthly total based on the 15 month previous to the month selected.These reports can only be run for a single product at a time.',
    data: [
      {
        key: 'OUS',
        value: 'Detailed Usage Report',
      },
      {
        key: 'DDU',
        value: 'Detailed Document Usage',
      },
      {
        key: 'DSU',
        value: 'Detailed Session Usage',
      },
      {
        key: 'DUBG',
        value: 'Document Usage By Group',
      },
      {
        key: 'SUBG',
        value: 'Session Usage By Group',
      },
      {
        key: 'ISR',
        value: 'Individual Site Report',
      },
    ],
  },
];
